import { render, staticRenderFns } from "./documents-create-edit-document-modal.vue?vue&type=template&id=ac7a08aa&scoped=true&"
import script from "./documents-create-edit-document-modal.vue?vue&type=script&lang=js&"
export * from "./documents-create-edit-document-modal.vue?vue&type=script&lang=js&"
import style0 from "./documents-create-edit-document-modal.vue?vue&type=style&index=0&id=ac7a08aa&lang=scss&scoped=true&"
import style1 from "./documents-create-edit-document-modal.vue?vue&type=style&index=1&id=ac7a08aa&lang=scss&"
import style2 from "./documents-create-edit-document-modal.vue?vue&type=style&index=2&id=ac7a08aa&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7a08aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac7a08aa')) {
      api.createRecord('ac7a08aa', component.options)
    } else {
      api.reload('ac7a08aa', component.options)
    }
    module.hot.accept("./documents-create-edit-document-modal.vue?vue&type=template&id=ac7a08aa&scoped=true&", function () {
      api.rerender('ac7a08aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/additions/modals/documents-create-edit-document-modal.vue"
export default component.exports